import axios from 'axios'

export const companiesRegistrationsStoreSites = {
  namespaced: true,
  state: {
    // [{ "1"(site_id): "URL" }, ..]
    data: [],
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    writeRegistrationsStoreSites(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    writeRegistrationsStoreSitesSuccess(state) {
      state.loading = false
    },
    writeRegistrationsStoreSitesFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  actions: {
    writeRegistrationsStoreSites({ commit, state }, payload) {
      if (state.loading) return false
      commit('writeRegistrationsStoreSites')
      const storeSites = payload.sites
        .filter((v) => state.data[v.id])
        .map((v) => {
          return {
            site_id: v.id,
            url: state.data[v.id]
          }
        })
      const submitData = {
        store_sites: storeSites
      }
      return axios
        .post('/api/companies/' + payload.companyUuid + '/registrations/stores/' + payload.storeUuid + '/sites', submitData)
        .then(() => {
          commit('writeRegistrationsStoreSitesSuccess')
          return true
        })
        .catch(err => {
          commit('writeRegistrationsStoreSitesFailure', err)
          console.error(err)
          return false
        })
    }
  }
}
